import React from 'react';

import PriceDetailsItem from './PriceDetailsItem';

const GroupedTickets = ({ tickets, currency }) => (
    tickets.map((ticket, index) => (
        <PriceDetailsItem key={index} name={ticket.name} price={ticket.price} noOfTickets={ticket.noOfTickets}
            currency={currency}
        />
    )));
export default GroupedTickets;
